export default () => Math.ceil(Math.random() * 99) * (Math.round(Math.random()) ? 1 : -1) / 100
